import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import './Layout.css';

export function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="layout">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <main className="main-content">
        {React.Children.map(children, child => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, { onMenuClick: toggleSidebar });
          }
          return child;
        })}
      </main>
    </div>
  );
}

export default Layout;
